<template>
  <section class="section has-text-centered">
    <div class="container">
      <p class="title is-size-4">Dictation</p>
      <p>Overall spelling performance in <b>dictation mode</b> per book.</p>
      <div class="columns is-centered is-multiline">
        <div
          v-for="dr in dictationRecords"
          :key="dr.bookId"
          class="column is-6"
        >
          <DictationBars
            :bookName="getBookById(dr.bookId).name"
            :correct="dr.correctSpellings"
            :wrong="dr.wrongSpellings"
            :height="125"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import DictationBars from "./Charts/DictationBars";
export default {
  props: ["dictationRecords"],
  components: { DictationBars },
  computed: {
    ...mapGetters(["getBookById"])
  }
};
</script>

<style lang="scss" scoped></style>
